import { render } from "./student-settings.vue?vue&type=template&id=efa8bbd0"
import script from "./student-settings.vue?vue&type=script&lang=js"
export * from "./student-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__